import { Component, OnInit } from '@angular/core';
import { PermissionService } from 'src/app/account/services/permission.service';
import { Globals } from 'src/app/shared/services/globals';

@Component({
  selector: 'app-examiner-menu',
  templateUrl: './examiner-menu.component.html',
  styleUrls: ['./examiner-menu.component.css']
})
export class ExaminerMenuComponent implements OnInit {
  permssions :[];
  constructor(public g:Globals,private permService:PermissionService ) { }

  ngOnInit() {
    this.permService.GetCompPermssions('ExaminerMenuComponent').toPromise().then(res=>
      {
        console.log('res');
        console.log((res as any).data )
   this.permssions=    (res as any).data;
   this.permssions.forEach(element => {
    if(document.getElementById((element as any).elementId))
    {
      console.log((element as any).elementId)
     document.getElementById((element as any).elementId).hidden=true;
    }
    });
   console.log('permissons');
   console.log(this.g.perms)
   this.g.getPermissions().forEach(element => {
     if(document.getElementById(element.elementId))
     {
      console.log(element.elementId);

    document.getElementById(element.elementId).hidden=!element.isReadWrite 

     document.getElementById(element.elementId).hidden=element.isHidden 
     }     
   });
      }
       )
  }

}
